export const AUTOMATION_TABS = [
  { id: 'workflows', label: 'Workflows' },
  { id: 'statistics', label: 'Statistics' },
  { id: 'templates', label: 'Templates' },
  { id: 'delivery-logs', label: 'Delivery Logs' },
  { id: 'settings', label: 'Settings' },
];

export const LEGACY_AUTOMATION_TAB_MAP = {
  'email-workflows': 'workflows',
  'unified-automations': 'workflows',
  unified: 'workflows',
  overview: 'statistics',
  'notification-templates': 'templates',
  'system-alerts': 'settings',
  alerts: 'settings',
  'delivery-logs': 'delivery-logs',
  logs: 'delivery-logs',
  settings: 'settings',
  workflows: 'workflows',
  statistics: 'statistics',
  templates: 'templates',
};

export const DEFAULT_AUTOMATION_TAB = 'workflows';

export function resolveAutomationTab(rawTab) {
  if (!rawTab) return DEFAULT_AUTOMATION_TAB;
  return LEGACY_AUTOMATION_TAB_MAP[rawTab] || rawTab;
}

export function isValidAutomationTab(tabId) {
  return AUTOMATION_TABS.some((tab) => tab.id === tabId);
}

export function normalizeAutomationTab(rawTab) {
  const resolved = resolveAutomationTab(rawTab);
  return isValidAutomationTab(resolved) ? resolved : DEFAULT_AUTOMATION_TAB;
}
